<script>
  import type { ITablePanel, TableAlignEnum } from "./Table.svelte";
  import { addThemeClass } from "../../../core";

  export let data: ITablePanel;

  function getAlign(align: TableAlignEnum): string {
    const alignObject: Record<string, string> = {
      "cell-right": "text-align: right;",
      "cell-center": "text-align: center;",
      "cell-left": "text-align: left;",
    };

    return alignObject[align];
  }
</script>

<table use:addThemeClass={data}>
  {#if data.table.useFirstRowAsHeader}
    <thead>
      <tr>
        {#each data.table.cells[0] as cell}
          <th scope="col" style={getAlign(cell.align)}>
            {@html cell.value}
          </th>
        {/each}
      </tr>
    </thead>
  {/if}

  <tbody>
    {#each data.table.cells.slice(1) as row}
      <tr>
        {#each row as cell, index}
          <td style={getAlign(cell.align)}>
            {@html cell.value}

            {#if index === 0}
              <slot {cell} />
            {/if}
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>

<style lang="scss">
  table {
    @include normal;
    width: 100%;
  }
  th {
    border-bottom: 1px solid #5f5f5f;
    padding: 18px 20px 12px;
    font-weight: 900;
    background-color: var(--background-color);
    color: var(--text-color);
  }
  td {
    border-bottom: 1px solid #5f5f5f;
    padding: 20px 20px;
  }

  :global(table.default-theme) {
    td {
      padding: 20px 0;
    }
    th {
      padding: 18px 0 12px;
    }
  }
</style>
